import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type LinkUsersOperation = paths["/dashboard/synota/link-users"]["post"];
export type UseNodeLinkUsersInput =
  LinkUsersOperation["requestBody"]["content"]["application/json"];
export type UseNodeLinkUsersResponse = void;

export const useNodeLinkUsers = () => {
  const { client } = useHttp();

  const { isPending, status, error, mutate } = useAxiosMfaMutation<
    UseNodeLinkUsersResponse,
    UseNodeLinkUsersInput
  >({
    mutationKey: ["link-node-users"],
    mutationFn: (input) => client.post("/synota/link-users", input),
  });

  useDefaultError(error, "Failed to link node users");

  return {
    linkUsers: mutate,
    isPending,
    status,
    error,
  };
};

export type UseNodeLinkUsersReturn = ReturnType<typeof useNodeLinkUsers>;
